import { render, staticRenderFns } from "./free-gift-drawer.vue?vue&type=template&id=d2913c1a&scoped=true&"
import script from "./free-gift-drawer.vue?vue&type=script&lang=js&"
export * from "./free-gift-drawer.vue?vue&type=script&lang=js&"
import style0 from "./free-gift-drawer.vue?vue&type=style&index=0&id=d2913c1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2913c1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
